import { Link, useLocation } from 'react-router-dom';
import { cn } from "@/lib/utils";
import {
  HomeIcon,
  BarChart3,
  UserRound,
} from "lucide-react";

const tabs = [
  { href: "/campaigns", label: "Campaigns", icon: HomeIcon },
  { href: "/dashboard", label: "Dashboard", icon: BarChart3 },
  { href: "/profile", label: "Profile", icon: UserRound },
];

export function BottomTabs() {
  const location = useLocation();
  const pathname = location.pathname;

  // Hide bottom tabs on public/auth pages
  if (pathname === "/" || pathname.startsWith("/auth")) {
    return null;
  }

  return (
    <nav className="sticky bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-xl border-t border-white/10 bg-zinc-950/95 backdrop-blur lg:hidden">
      <ul className="grid grid-cols-3 text-xs text-white/70">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = pathname.startsWith(tab.href);
          return (
            <li key={tab.href}>
              <Link
                to={tab.href}
                className={cn(
                  "flex flex-col items-center gap-1 py-3 transition",
                  isActive ? "text-white" : "text-white/50 hover:text-white"
                )}
              >
                <Icon className="h-5 w-5" />
                {tab.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
